import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { SampleManufacturerQuestions, SampleOperatorQuestions } from '../../../../consts/SampleQuestions'
import SampleQuestion from './../SampleQuestion'
import { StyledInitialScreen, StyledBackgroundImage, StyledIntroductionMessage, StyledIntroductionSubMessage, StyledIntroductionScreen } from './styled'
import getOrientation from '../../../../utils/getOrientation'
import getForcedMobile from '../../../../utils/forceMobile'
import { parsePlatformId } from '../../../../utils/parsePlatformId'
import { Circle, LiveHelpOutlined } from '@mui/icons-material'

interface InitialScreenProps {
  handleSampleQuestion: (arg: string) => void
}

const InitialScreen: React.FC<InitialScreenProps> = ({ handleSampleQuestion }): JSX.Element => {
  const theme = useTheme()
  const isPortrait = getOrientation()
  const forcedMobile = getForcedMobile()
  const username = localStorage.getItem('userName') ?? ''
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const storedPlatformId = localStorage.getItem('platformId')
  const platformId = parsePlatformId(storedPlatformId?.toString() ?? '')
  const userQuestions = localStorage.getItem('sample_questions') ?? ''
  const [splitPlatformId, setSplitPlatformId] = useState<string[]>([])
  const [specifiedQuestions, setSpecifiedQuestions] = useState<Array<{ text: string }>>([])

  const chooseQuestions = (): void => {
    if (userQuestions !== '') {
      setSpecifiedQuestions(JSON.parse(userQuestions))
    } else {
      if (splitPlatformId[0] === 'MA') {
        setSpecifiedQuestions(SampleManufacturerQuestions)
      } else if (splitPlatformId[0] === 'CL') {
        setSpecifiedQuestions(SampleOperatorQuestions)
      } else {
        setSpecifiedQuestions([])
      }
    }
  }

  useEffect(() => {
    setSplitPlatformId(platformId[0]?.split('-'))
  }, [])

  useEffect(() => {
    chooseQuestions()
  }, [splitPlatformId])

  return (
    <StyledInitialScreen>
      <StyledIntroductionScreen>
        <StyledBackgroundImage>
          <Circle style={{ color: '#F2F2F2', width: '50px', height: '50px' }} />
          <LiveHelpOutlined style={{ color: '#333D40', position: 'absolute' }} />
        </StyledBackgroundImage>
        <StyledIntroductionMessage>
          {username !== '' ? `Hey there, ${username}!` : 'Hey there!'}
        </StyledIntroductionMessage>
        <StyledIntroductionSubMessage>
            What can I help you with?
        </StyledIntroductionSubMessage>
      </StyledIntroductionScreen>
      <Grid container spacing={isMobile || isPortrait || forcedMobile ? '20px' : '12px'}>
        {specifiedQuestions?.map((question, index) => (
          <Grid item xs={6} sm={3} md={3} lg={3} key={index}>
            <SampleQuestion
              key={index}
              text={question.text}
              sampleQuestionClick={() => { handleSampleQuestion(question.text) }}
            />
          </Grid>
        ))}
      </Grid>
    </StyledInitialScreen>
  )
}

export default InitialScreen
